// extracted by mini-css-extract-plugin
export default {"product__descr":"ProductDescr_product__descr__ldN4q","product__title":"ProductDescr_product__title__g+YiP","product__text":"ProductDescr_product__text__A0xaW"};